export default {
  white: '#ffffff',
  black: '#000000',
  gray: {
    100: '#f9f9f9',
    200: '#f3f3f3',
    300: '#eee',
    400: '#e6e6e6',
    500: '#ddd',
    600: '#999',
    700: '#666',
    800: '#222',
  },
  blueGray: {
    200: '#c6cddc',
    300: '#a6adbb',
    400: '#878e9a',
    600: '#1d232d',
    700: '#171a24',
    800: '#12151c',
    900: '#0a0a10',
  },
  darkBlue: '#343f6a',
  blue: '#5a86cb',
  lightBlue: '#86b6ea',
  lightYellow: '#f3efab',
};
